import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/materials/materials-list')({
  staticData: toStaticData(CRT_ROUTES['/crt/materials/materials-list']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
